"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactTable = require("@tanstack/react-table");
var _Table = require("./Table.styled");
var _reactVirtual = require("@tanstack/react-virtual");
var _TextColumn = _interopRequireDefault(require("../../../components/data-display/table/column/TextColumn"));
var _IconColumn = _interopRequireDefault(require("../../../components/data-display/table/column/IconColumn"));
var _ActionColumn = _interopRequireDefault(require("../../../components/data-display/table/column/ActionColumn"));
var _DropdownColumn = _interopRequireDefault(require("../../../components/data-display/table/column/DropdownColumn"));
var _Cell = require("./cell/Cell.styled");
var _ExpandChevron = _interopRequireDefault(require("../../../components/data-display/table/ExpandChevron"));
var _AvatarColumn = _interopRequireDefault(require("../../../components/data-display/table/column/AvatarColumn"));
var _reactIntl = require("react-intl");
var _CurrencyColumn = _interopRequireDefault(require("../../../components/data-display/table/column/CurrencyColumn"));
var _NumberColumn = _interopRequireDefault(require("../../../components/data-display/table/column/NumberColumn"));
var _TimeColumn = _interopRequireDefault(require("../../../components/data-display/table/column/TimeColumn"));
var _GroupingColumn = _interopRequireDefault(require("../../../components/data-display/table/column/GroupingColumn"));
var _ColumnUtils = require("./column/support/ColumnUtils");
var _ColumnGroup = _interopRequireDefault(require("../../../components/data-display/table/column/ColumnGroup"));
var _PercentageColumn = _interopRequireDefault(require("../../../components/data-display/table/column/PercentageColumn"));
var _ArrayColumn = _interopRequireDefault(require("../../../components/data-display/table/column/ArrayColumn"));
var _ButtonColumn = _interopRequireDefault(require("../../../components/data-display/table/column/ButtonColumn"));
var _ExportData = require("./ExportData");
var _ExportOnlyColumn = _interopRequireDefault(require("../../../components/data-display/table/column/ExportOnlyColumn"));
var _ColoredIdIconColumn = _interopRequireDefault(require("../../../components/data-display/table/column/ColoredIdIconColumn"));
var _DateColumn = _interopRequireDefault(require("../../../components/data-display/table/column/DateColumn"));
var _virtualCore = require("@tanstack/virtual-core");
var _RowSelectionCheckbox = require("./RowSelectionCheckbox");
var _filtersWithHighlighting = require("./sorting/filtersWithHighlighting");
var _jsxRuntime = require("react/jsx-runtime");
var ROW_DEPTH_INDENT = 52; // globalSpacing['400'] * 2 + checkbox width (20px)
var ROW_HEIGHT_ESTIMATE = 61;
var Table = function Table(_ref) {
  var tableRef = _ref.tableRef,
    grouping = _ref.grouping,
    width = _ref.width,
    height = _ref.height,
    data = _ref.data,
    searchValue = _ref.searchValue,
    hasVerticalStrokes = _ref.hasVerticalStrokes,
    children = _ref.children,
    _ref$showFooter = _ref.showFooter,
    showFooter = _ref$showFooter === void 0 ? false : _ref$showFooter,
    onSelectionChange = _ref.onSelectionChange,
    onFilteringChange = _ref.onFilteringChange,
    enableRowSelection = _ref.enableRowSelection,
    scrollRef = _ref.scrollRef,
    stickyHeader = _ref.stickyHeader,
    _ref$initialSorting = _ref.initialSorting,
    initialSorting = _ref$initialSorting === void 0 ? [] : _ref$initialSorting,
    dataCy = _ref['data-cy'],
    getRowId = _ref.getRowId,
    autoResetExpanded = _ref.autoResetExpanded,
    highlightSearch = _ref.highlightSearch;
  var tableContainerRef = (0, _react.useRef)(null);
  var tableRowProps = {
    hasVerticalStrokes: hasVerticalStrokes
  };
  var _ref2 = (0, _react.useState)(initialSorting),
    _ref3 = _slicedToArray(_ref2, 2),
    sorting = _ref3[0],
    setSorting = _ref3[1];
  var _ref4 = (0, _react.useState)({}),
    _ref5 = _slicedToArray(_ref4, 2),
    rowSelection = _ref5[0],
    setRowSelection = _ref5[1];
  var columnStateAccessor = (0, _react.useState)({});
  var intl = (0, _reactIntl.useIntl)();
  var translatedGroupings = (0, _react.useMemo)(function () {
    return grouping === null || grouping === void 0 ? void 0 : grouping.map(function (group) {
      return (0, _ColumnUtils.accessKeyToId)(group);
    });
  }, [grouping]);
  var columnDefs = (0, _react.useMemo)(function () {
    return (0, _ColumnUtils.toColumnDefs)(children, intl, translatedGroupings, columnStateAccessor);
  }, [children, intl, translatedGroupings, columnStateAccessor]);
  var columnVisibility = (0, _react.useMemo)(function () {
    return (0, _ColumnUtils.getColumnVisibility)(columnDefs, grouping);
  }, [columnDefs, grouping]);
  var totals = (0, _react.useMemo)(function () {
    return (0, _ColumnUtils.calculateTotals)(showFooter, data);
  }, [data, showFooter]);
  var _ref6 = (0, _react.useState)([]),
    _ref7 = _slicedToArray(_ref6, 2),
    scrollToHighlightIds = _ref7[0],
    setScrollToHighlightIds = _ref7[1];
  var _ref8 = (0, _react.useState)(null),
    _ref9 = _slicedToArray(_ref8, 2),
    scrollToIdAfterExpand = _ref9[0],
    setScrollToIdAfterExpand = _ref9[1];
  var _ref10 = (0, _react.useState)(undefined),
    _ref11 = _slicedToArray(_ref10, 2),
    globalFilter = _ref11[0],
    setGlobalFilter = _ref11[1];
  (0, _react.useEffect)(function () {
    setGlobalFilter(searchValue ? {
      multiterm: true,
      term: searchValue
    } : undefined);
  }, [searchValue]);
  var table = (0, _reactTable.useReactTable)({
    data: data,
    columns: columnDefs,
    enableRowSelection: enableRowSelection,
    onSortingChange: setSorting,
    getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
    getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
    getGroupedRowModel: grouping ? (0, _reactTable.getGroupedRowModel)() : undefined,
    getFilteredRowModel: (0, _reactTable.getFilteredRowModel)(),
    onRowSelectionChange: setRowSelection,
    getSubRows: function getSubRows(row) {
      return row.rows;
    },
    getExpandedRowModel: (0, _reactTable.getExpandedRowModel)(),
    globalFilterFn: highlightSearch ? _filtersWithHighlighting.globalFilterWithHighlighting : 'includesString',
    meta: {
      totals: totals
    },
    state: {
      grouping: translatedGroupings,
      globalFilter: highlightSearch ? globalFilter : searchValue,
      sorting: sorting,
      columnVisibility: columnVisibility,
      rowSelection: rowSelection
    },
    getRowId: getRowId,
    autoResetExpanded: autoResetExpanded
  });
  var expandParents = function expandParents(row) {
    var parentRows = row.getParentRows();
    var _iterator = _createForOfIteratorHelper(parentRows),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var parentRow = _step.value;
        if (!parentRow.getIsExpanded()) {
          parentRow.toggleExpanded();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  var _scrollToId = function scrollToId(id) {
    var row = flatRows.find(function (row) {
      return row.id === id && !row.groupingValue;
    });
    if (row) {
      expandParents(row);
      setScrollToIdAfterExpand(id);
    }
  };
  (0, _react.useImperativeHandle)(tableRef, function () {
    return {
      clearSelections: function clearSelections() {
        return table.resetRowSelection();
      },
      exportData: function exportData(fileName, exportType, includeColumns) {
        return (0, _ExportData.exportData)(table, fileName, exportType, includeColumns);
      },
      setSelections: function setSelections(ids) {
        return table.setRowSelection(Object.fromEntries(ids.map(function (id) {
          return [id, true];
        })));
      },
      scrollToId: function scrollToId(id) {
        return _scrollToId(id);
      }
    };
  });
  (0, _react.useEffect)(function () {
    if (onSelectionChange) {
      onSelectionChange(table.getSelectedRowModel().flatRows.map(function (row) {
        return row.original;
      }));
    }
  }, [rowSelection, table, onSelectionChange]);
  var _table$getRowModel = table.getRowModel(),
    rows = _table$getRowModel.rows,
    flatRows = _table$getRowModel.flatRows;
  (0, _react.useEffect)(function () {
    if (onFilteringChange) {
      onFilteringChange(table.getFilteredRowModel().flatRows.map(function (row) {
        return row.original;
      }));
    }
  }, [searchValue, table, rows.length, onFilteringChange]);
  var scrollElement = scrollRef !== null && scrollRef !== void 0 ? scrollRef : tableContainerRef;
  var virtualizer = (0, _reactVirtual.useVirtualizer)({
    count: rows.length,
    overscan: 5,
    getScrollElement: function getScrollElement() {
      return scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.current;
    },
    estimateSize: function estimateSize() {
      return ROW_HEIGHT_ESTIMATE;
    },
    observeElementOffset: function observeElementOffset(instance, cb) {
      return (0, _virtualCore.observeElementOffset)(instance, function (offset) {
        var _tableContainerRef$cu, _tableContainerRef$cu2;
        var topOffset = (_tableContainerRef$cu = tableContainerRef === null || tableContainerRef === void 0 ? void 0 : (_tableContainerRef$cu2 = tableContainerRef.current) === null || _tableContainerRef$cu2 === void 0 ? void 0 : _tableContainerRef$cu2.offsetTop) !== null && _tableContainerRef$cu !== void 0 ? _tableContainerRef$cu : 0;
        cb(Math.max(offset - topOffset, 0));
      });
    }
  });
  (0, _react.useEffect)(function () {
    virtualizer._willUpdate();
  }, [virtualizer]);
  var virtualRows = virtualizer.getVirtualItems();
  var totalSize = virtualizer.getTotalSize();
  var paddingTop = virtualRows.length > 0 ? virtualRows[0].start || 0 : 0;
  var paddingBottom = virtualRows.length > 0 ? totalSize - (virtualRows[virtualRows.length - 1].end || 0) : 0;
  var isSelectable = !!onSelectionChange;
  var footerGroup = showFooter && table.getFooterGroups()[0];
  var doScrollToIdAfterExpand = function doScrollToIdAfterExpand(id) {
    var index = rows.findIndex(function (row) {
      return row.id === id;
    });
    if (index !== -1) {
      setScrollToHighlightIds([].concat(_toConsumableArray(scrollToHighlightIds), [id]));
      virtualizer.scrollToIndex(index, {
        align: 'center'
      });
    }
  };
  var clearHighlight = function clearHighlight(id) {
    setTimeout(function () {
      setScrollToHighlightIds(function (prevState) {
        return prevState.filter(function (i) {
          return i !== id;
        });
      });
    }, 2000);
  };
  if (scrollToIdAfterExpand) {
    doScrollToIdAfterExpand(scrollToIdAfterExpand);
    setScrollToIdAfterExpand(null);
    clearHighlight(scrollToIdAfterExpand);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: tableContainerRef,
    style: {
      height: height
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table.StyledTable, {
      style: {
        width: width
      },
      "data-cy": dataCy,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("thead", {
        children: table.getHeaderGroups().map(function (headerGroup, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.StyledTableRow, _objectSpread({
            header: true
          }, tableRowProps, {
            children: headerGroup.headers.map(function (header) {
              var _meta$dataCy;
              var meta = header.column.columnDef.meta;
              var dataCy = (_meta$dataCy = meta === null || meta === void 0 ? void 0 : meta.dataCy) !== null && _meta$dataCy !== void 0 ? _meta$dataCy : header.column.columnDef.id;
              return header.isPlaceholder || meta !== null && meta !== void 0 && meta.hideHeader ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.StyledTableCell, {
                colSpan: header.colSpan,
                header: true,
                stickyHeader: stickyHeader,
                "aria-label": meta === null || meta === void 0 ? void 0 : meta.header,
                width: meta === null || meta === void 0 ? void 0 : meta.width,
                "data-cy": dataCy
              }, header.id) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.StyledTableHead, {
                colSpan: header.colSpan,
                header: true,
                stickyHeader: stickyHeader,
                "aria-label": meta === null || meta === void 0 ? void 0 : meta.header,
                width: meta === null || meta === void 0 ? void 0 : meta.width,
                "data-cy": dataCy,
                children: header.index === 0 && isSelectable ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_RowSelectionCheckbox.CheckboxWrapper, {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RowSelectionCheckbox.HeaderSelectionCheckbox, {
                    table: table
                  }), (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())]
                }) : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
              }, header.id);
            })
          }), headerGroup.id);
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("tbody", {
        children: [paddingTop > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
            style: {
              height: "".concat(paddingTop, "px")
            }
          })
        }), virtualRows.map(function (virtualRows) {
          var row = rows[virtualRows.index];
          var depth = grouping !== null && grouping !== void 0 && grouping.length || row.parentId ? row.depth : 0; // Workaround: If row was > 0 earlier, but 0 now, it's not reset correctly.
          var shouldHighlight = scrollToHighlightIds.includes(row.id);
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.StyledTableRow, _objectSpread({
            onClick: row.getToggleExpandedHandler(),
            "aria-selected": row.getIsSelected(),
            "data-highlight": shouldHighlight,
            lastRow: virtualRows.index === rows.length - 1
          }, tableRowProps, {
            children: row.getVisibleCells().map(function (cell, index) {
              var _meta$dataCy2;
              var columnDef = cell.column.columnDef;
              var meta = columnDef.meta;
              var dataCy = (_meta$dataCy2 = meta === null || meta === void 0 ? void 0 : meta.dataCy) !== null && _meta$dataCy2 !== void 0 ? _meta$dataCy2 : columnDef.id;
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.StyledTableCell, {
                width: meta === null || meta === void 0 ? void 0 : meta.width,
                "data-cy": dataCy,
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Cell.CellContainer, {
                  style: {
                    paddingLeft: index === 0 ? depth * ROW_DEPTH_INDENT : 0
                  },
                  children: [isSelectable && index === 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RowSelectionCheckbox.CheckboxWrapper, {
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RowSelectionCheckbox.RowSelectionCheckbox, {
                      row: row
                    })
                  }), row.getCanExpand() && index === 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandChevron.default, {
                    expanded: row.getIsExpanded()
                  }), (0, _reactTable.flexRender)(columnDef.cell, cell.getContext())]
                })
              }, cell.id);
            })
          }), row.id);
        }), paddingBottom > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
            style: {
              height: "".concat(paddingBottom, "px")
            }
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tfoot", {
        children: footerGroup && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.StyledTableRow, _objectSpread({
          footer: true
        }, tableRowProps, {
          children: footerGroup.headers.map(function (header) {
            var _meta$dataCy3;
            var columnDef = header.column.columnDef;
            var meta = columnDef.meta;
            var dataCy = (_meta$dataCy3 = meta === null || meta === void 0 ? void 0 : meta.dataCy) !== null && _meta$dataCy3 !== void 0 ? _meta$dataCy3 : columnDef.id;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.StyledTableCell, {
              colSpan: header.colSpan,
              header: true,
              width: meta === null || meta === void 0 ? void 0 : meta.width,
              "data-cy": dataCy,
              children: (0, _reactTable.flexRender)(columnDef.footer, header.getContext())
            }, header.id);
          })
        }), footerGroup.id)
      })]
    })
  });
};
Table.GroupingColumn = _GroupingColumn.default;
Table.ColumnGroup = _ColumnGroup.default;
Table.ArrayColumn = _ArrayColumn.default;
Table.AvatarColumn = _AvatarColumn.default;
Table.TextColumn = _TextColumn.default;
Table.CurrencyColumn = _CurrencyColumn.default;
Table.DateColumn = _DateColumn.default;
Table.NumberColumn = _NumberColumn.default;
Table.TimeColumn = _TimeColumn.default;
Table.IconColumn = _IconColumn.default;
Table.PercentageColumn = _PercentageColumn.default;
Table.ActionColumn = _ActionColumn.default;
Table.DropdownColumn = _DropdownColumn.default;
Table.ButtonColumn = _ButtonColumn.default;
Table.ExportOnlyColumn = _ExportOnlyColumn.default;
Table.ColoredIdIconColumn = _ColoredIdIconColumn.default;
Table.Align = _Cell.Align;
var _default = exports.default = Table;